import {
	Code,
	Combobox,
	createTheme,
	Input,
	InputBase,
	LoadingOverlay,
	Modal,
	MultiSelect,
	NavLink,
	Radio,
	Select,
	Text,
} from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import variants from './CustomVariants.module.css';

export const theme = createTheme({
	fontFamily: 'Roboto, sans-serif',
	colors: {
		medepos: [
			'#212428',
			'#708090',
			'#9eb8d3',
			'#1C4146',
			'#94989E',
			'#D1FAFF',
			'#9E544F',
			'#E2CF6E',
			'',
			'',
			'',
		],
		'medepos-secondary': [
			// Make these more fluorescent
			'#708090',
			'#9eb8d3',
			'#94989E',
			'',
			'',
			'',
			'',
			'',
			'',
			'',
			'',
		],
	},
	defaultRadius: 'sm',
	components: {
		// biome-ignore lint/style/useNamingConvention: required by Mantine lib
		Modal: Modal.extend({
			defaultProps: {
				transitionProps: {
					transition: 'pop',
				},
			},
		}),
		NavLink: NavLink.extend({
			defaultProps: {
				disableRightSectionRotation: true,
			},
		}),
		DatePickerInput: DatePickerInput.extend({
			defaultProps: {
				valueFormat: 'DD MMMM YYYY',
			},
			classNames: variants,
		}),
		Combobox: Combobox.extend({
			defaultProps: {
				floatingStrategy: 'fixed', // Fixes stupid issue
			},
			classNames: variants,
		}),
		Input: Input.extend({
			classNames: variants,
		}),
		InputBase: InputBase.extend({
			classNames: variants,
		}),
		Select: Select.extend({
			defaultProps: {
				comboboxProps: {
					floatingStrategy: 'fixed', // Fixes stupid issue
				},
			},
			classNames: variants,
		}),
		MultiSelect: MultiSelect.extend({
			defaultProps: {
				comboboxProps: {
					floatingStrategy: 'fixed',
				},
			},
		}),
		Code: Code.extend({
			defaultProps: {
				style: { backgroundColor: 'transparent' },
			},
		}),
		Text: Text.extend({
			defaultProps: {
				size: 'sm',
			},
		}),
		Radio: Radio.extend({
			defaultProps: {
				color: 'medepos.1',
			},
		}),
		LoadingOverlay: LoadingOverlay.extend({
			defaultProps: {
				loaderProps: {
					color: 'medepos.1',
					type: 'dots',
				},
				overlayProps: {
					center: true,
					zIndex: 1000000,
				},
				zIndex: 100000,
			},
		}),
	},
});
